import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getViewName, interactionBackButtonModal, interactionMfaByApp, interactionMfaByEmail, interactionResend, interactionRioEventCloseModal, interactionVerifyDifferentWay } from "./rio";
import { EventTypes, recordEvents } from "../../utils/newRelic/newRelicEvents";
export { registerClickListener };
function registerClickListener(base, store) {
  var root = findRoot(base);
  root.addEventListener('click', onClick);
  return function () {
    root.removeEventListener('click', onClick);
  };
  function onClick(e) {
    var name = findTarget(e.target, root);
    if (name) {
      handleElementClick(name, store.getState());
      return;
    }
  }
}
function handleElementClick(name, state) {
  recordEvents(_defineProperty({}, EventTypes.mfaByAppClick, {
    click_on: name
  }));
  var uuid = state.authParams.uuid;
  var currentRoute = state.router.current_route;
  switch (name) {
    case 'factor_selection_mfa_by_app_button':
      interactionMfaByApp(uuid);
      return;
    case 'factor_selection_mfa_by_email_button':
      interactionMfaByEmail(uuid);
      return;
    case 'push_sent_retry_link':
    case 'general_error_footer_link':
      interactionResend(getViewName(currentRoute), uuid);
      return;
    case 'push_sent_navigate_link':
    case 'os_push_declined_navigate_link':
    case 'app_push_declined_retry_link':
      interactionVerifyDifferentWay(getViewName(currentRoute), uuid);
      return;
    case 'go-back':
      interactionBackButtonModal(getViewName(currentRoute), uuid);
      return;
    case 'close dialog':
      interactionRioEventCloseModal(getViewName(currentRoute), uuid);
      return;
  }
}

// Climb up the tree looking for first rio target, and return its name
function findTarget(el, root) {
  do {
    var name = el.getAttribute('data-rio-target');
    var label = el.getAttribute('aria-label');
    if (name) {
      return name;
    }
    // some chegg-ui components can't be assigned attributes, so we need to target them by
    // their labels instead
    if (el.tagName.toLowerCase() == 'button' && label) {
      return label;
    }
    el = el.parentElement;
  } while (el != root);
  return null;
}

// Since we can't ref the dialog container, we need to find it by climbing up the tree.
// Adding guardrails to prevent possible endless recursions
function findRoot(el) {
  var root = el.parentElement;
  while (root.parentElement && root.id != 'mfa-dialog-container' && root != document.body) {
    root = root.parentElement;
  }
  return root;
}